module.exports = __webpack_public_path__ + "img/s3.47bac282.png";